import { PROFILE_PICTURE_PLACEHOLDER } from '@lmc/common/constants'
import { Avatar as AntdAvatar } from 'antd'
import type { ReactElement } from 'react'
import styled, { css } from 'styled-components'

export type AvatarProps = {
  onClick?: () => void
  size?: number | 'large' | 'default' | 'small'
  style?: object
  url?: string
  className?: string
  border?: boolean
  hoverable?: boolean
}

export default function Avatar({
  onClick,
  size,
  style,
  url = PROFILE_PICTURE_PLACEHOLDER,
  className,
  border = false,
  hoverable = false,
  ...props
}: AvatarProps): ReactElement {
  const avatarStyle = {
    ...(!!onClick && { cursor: 'pointer' }),
    ...style
  }

  return (
    <AntdAvatarStyled
      role="link"
      clickable={Boolean(onClick)}
      className={className}
      onClick={onClick}
      size={size}
      src={url || PROFILE_PICTURE_PLACEHOLDER}
      style={avatarStyle}
      hoverable={hoverable}
      border={border}
      {...props}
    />
  )
}

type AntdAvatarStyledProps = {
  clickable: boolean
  role?: 'link'
  hoverable: boolean
  border: boolean
}
const AntdAvatarStyled = styled(AntdAvatar).withConfig({
  shouldForwardProp: (prop) =>
    !['clickable', 'hoverable', 'border'].includes(prop)
})<AntdAvatarStyledProps>`
  ${(props) =>
    props.clickable &&
    css`
      cursor: pointer;
    `}

  ${(props) =>
    props.border &&
    css`
      border: 1px solid ${({ theme }) => theme.color.neutral.color3};
    `}

  ${(props) =>
    props.hoverable &&
    css`
      &:hover {
        cursor: pointer;
        border: 1px solid ${({ theme }) => theme.color.neutral.color6};
      }
    `}
`
